import { IconButton } from '@chakra-ui/react'
import pluralize from 'pluralize'
import { type FC, useState } from 'react'
import { FiTrash2 } from 'react-icons/fi'

import { toaster } from '@app/components/ui/toaster'
import ConfirmPopover from '@app/shared/confirmPopover'
import { useStore } from '@app/store'

type Props = {
  type: string
  selected: (string | number)[]
  onDelete?: () => void
}

const MultiDeleteButton: FC<Props> = ({ type, selected, onDelete = null }) => {
  const [loading, setLoading] = useState(false)
  const bulkDelete = useStore.use.bulkDelete()
  const count = selected.length
  const humanizedType = type === 'basicCard' ? 'card' : type
  const pluralized = type === 'entity' ? 'work' : pluralize(humanizedType, count)
  const deleteObject = async () => {
    if (count === 0) {
      return
    }

    setLoading(true)

    try {
      await bulkDelete([{ [type]: selected }], { updatePageCounts: true })

      toaster.create({ title: `Deleted ${count} ${pluralized}` })

      onDelete?.()
    } finally {
      setLoading(false)
    }
  }

  return (
    <ConfirmPopover
      onConfirm={deleteObject}
      header={`Delete ${pluralized}`}
      body="Are you sure? You can&#39;t undo this action afterwards."
      confirmButtonText="Delete"
      loading={loading}
    >
      <IconButton color="error" aria-label={`Delete ${type}`} data-cy={`${type}-delete-button`} variant="ghost">
        <FiTrash2 />
      </IconButton>
    </ConfirmPopover>
  )
}

export default MultiDeleteButton
